import type { ButtonProps } from '../Button';

export interface WhatsappButtonData {
  label?: string;
}

export interface WhatsappButtonProps extends WhatsappButtonData, ButtonProps {}
